import { FeatureFlag, FeatureFlags } from '@mkp/debug/models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const debugActions = createActionGroup({
  source: 'Debug',
  events: {
    'Toggle Editable Content': emptyProps(),
    'Force Refresh': emptyProps(),
    'Toggle Feature Flag': props<{ featureFlag: FeatureFlag; value: boolean }>(),
    'Set Environment Defaults': props<{ defaultFlags: FeatureFlags; isLocked: boolean }>(),
  },
});
